// extracted by mini-css-extract-plugin
export default {"page":"styles_page_fgGnV","filters":"styles_filters_eHGSR","sections":"styles_sections_rtulG","section":"styles_section_jHxm1","items":"styles_items_QMKON"};